import { PayloadAction } from '@reduxjs/toolkit';

import { GridConfigState, GridEvent } from 'editor/src/store/gridConfig/types';

const setGridEventsReducer = (state: GridConfigState, action: PayloadAction<GridEvent[]>) => {
  state.gridEvents = action.payload;
};

export default setGridEventsReducer;
